module.exports = __webpack_public_path__ + "static/media/companyLocation.9dc6dcbe.png";